import {bymoTemplateMetadataFactoryCreate} from "../../../doppe-sdk";
import {BymoPagePropsSpecialContentSettingMetadata} from "../../../client-server-common";


export namespace BymoTemplatePagePreview {

    export interface TemplateProps {
        showSocialIconsSkeleton: boolean;
        showProfileTitleSkeleton: boolean;
        showProfileBioSkeleton: boolean;
        showProfilePictureSkeleton: boolean;
        mobileContentInlinePaddingCss: string;
        skeletonButtonsCount: number;
        prefixSkeletonActionButtonsCount: number;
        /**
         * When `true`, renders the user's actual {@link DoppeLayoutSocialLinks}
         * (with real chrome inherited from the page button template) instead
         * of skeleton dots. Used by the social-links "Icon style" preview so
         * the thumbnail mirrors the real page rendering. Default: `false`.
         */
        renderActualSocialIcons: boolean;
    }
}

const initialValues = {
    showSocialIconsSkeleton: true,
    showProfileTitleSkeleton: true,
    showProfileBioSkeleton: true,
    showProfilePictureSkeleton: true,
    mobileContentInlinePaddingCss: '18px',
    skeletonButtonsCount: 0,
    prefixSkeletonActionButtonsCount: 0,
    renderActualSocialIcons: false
} as BymoTemplatePagePreview.TemplateProps;


export const BymoTemplatePagePreviewMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplatePagePreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {
        mobileContentInlinePaddingCss: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        skeletonButtonsCount: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        prefixSkeletonActionButtonsCount: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showSocialIconsSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfileTitleSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfileBioSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        showProfilePictureSkeleton: BymoPagePropsSpecialContentSettingMetadata.Ignored,
        renderActualSocialIcons: BymoPagePropsSpecialContentSettingMetadata.Ignored,
    },
    features: [
        'hasActions', 'hasActionButton'
    ]
})